import React, { createContext, useContext } from "react";
import { notification } from "antd";

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  // Function to trigger notifications globally
  const openNotification = (
    type,
    message,
    description,
    placement = "bottomRight",
    pauseOnHover
  ) => {
    api[type]({
      message,
      description,
      placement,
      showProgress: true,
      pauseOnHover,
      duration: 8,
    });
  };

  return (
    <NotificationContext.Provider value={openNotification}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

// Custom hook to use the notification in any component
export const useNotification = () => {
  return useContext(NotificationContext);
};
